import React, { FC } from 'react';
import { FieldWrapper } from '@td-client-frontend/common';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import { GroupCodesWithReadOnly } from '../../../../@types/Groups';

const INPUT_VIEW_NUMBER: number = 3;

interface GroupCodesProps {
  label: string;
  path: string;
  onLabelClick: () => void;
}

const GroupCodes: FC<GroupCodesProps> = ({ label, path, onLabelClick }) => {
  const { watch } = useFormContext();
  const editCodes: GroupCodesWithReadOnly[] = watch(path) || [];

  const isDots: boolean = editCodes.length > INPUT_VIEW_NUMBER;
  const pill: string[] = editCodes.reduce((acc: string[], item: GroupCodesWithReadOnly, index: number) => {
    if (index < INPUT_VIEW_NUMBER) {
      acc.push(item.code.slice(0, 4));
    }
    return acc;
  }, []);

  return (
    <>
      <FieldWrapper
        label={label}
        isError={false}
        error=""
        labelBtnType={editCodes?.length ? 'Edit' : 'Add'}
        hideIcon={editCodes?.length}
        additionalClasses="col-span-3"
        fieldLabelBtnClasses="ml-1 pt-0 h-4 border-b-0"
        labelBtn={onLabelClick}
        labelClasses={clsx(
          'block mb-2 text-sm font-bold tracking-wide font-effra text-black-default',
          !editCodes?.length && 'mr-5'
        )}
      >
        <div className="relative h-9">
          <div
            className={clsx(
              'form-field flex items-center overflow-none absolute top-0 h-auto min-h-12 bg-white p-3 pl-0',
              'border-none resize-none scroll-none',
              false && 'form-field-error'
            )}
            tabIndex={-1}
          >
            {!editCodes.length ? (
              <h3 className="text-left text-gray-40 text-sm font-medium font-effra">No plan code</h3>
            ) : (
              pill.map((pill) => {
                return (
                  <div
                    key={pill}
                    className="flex items-center justify-between flex-grow-0 h-6 px-1 py-1 mr-2 border rounded bg-gray-15 border-gray-40 hover:border-gray-default hover:shadow min-w-10"
                  >
                    {pill}
                  </div>
                );
              })
            )}
            {isDots && <span className="ml-2 w-6 mt-1.5 mr-3">&hellip;</span>}
          </div>
        </div>
      </FieldWrapper>
    </>
  );
};

export default GroupCodes;
